import React from "react";
import { EyeIcon, UserIcon } from "../../../components/CommonSvg";
import { FIXED_COLUMNS, memberName } from "./memberColumns";

const MemberTable = ({ rows, optionalColumns, onSort, onView }) => (
    <div className="vp-mtable-wrap">
        <table className="vp-mtable">
            <thead>
                <tr>
                    {[...FIXED_COLUMNS, ...optionalColumns].map((column) => (
                        <th
                            key={column.key}
                            onClick={
                                column.sortable === false
                                    ? undefined
                                    : () => onSort(column.key)
                            }
                        >
                            {column.label}
                            {column.sortable !== false && <span className="sort">⇅</span>}
                        </th>
                    ))}
                    <th className="vp-mactions-head" />
                </tr>
            </thead>
            <tbody>
                {rows.map((member) => (
                    <tr className="vp-mrow no_expand" key={member.hraMemberId}>
                        <td>
                            <span className="vp-hra-chip">{member.hraMemberId}</span>
                        </td>
                        <td className="mstrong">{member.storeNameRegular || "—"}</td>
                        <td>
                            <span className="vp-mwith-icon">
                                <UserIcon />
                                {memberName(member) || "—"}
                            </span>
                        </td>
                        {optionalColumns.map((column) => (
                            <td key={column.key} className={column.className}>
                                {column.render(member)}
                            </td>
                        ))}
                        <td className="vp-mactions">
                            <span className="vp-mrow-actions">
                                <button
                                    type="button"
                                    className="vp-mview"
                                    title="View member"
                                    onClick={() => onView(member)}
                                >
                                    <EyeIcon />
                                </button>
                            </span>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default MemberTable;
